import InputForm from '../components/InputForm';

export const validateEmail = (value) => {
    const emailRegex = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    return emailRegex.test(value);
}

export const validateSenha = (value) => {
    return !!value && value.length >= 6 && value.length <= 10;
}

export const validateCPF = (value = '') => {
    const cpf = value.replace(/[^0-9]/g, '');
    return !!cpf && cpf.length === 11;
}

export function CPFValido(strCPF) {
    var Soma;
    var Resto;
    Soma = 0;
    if ((strCPF == "00000000000") ||
        (strCPF == "11111111111") ||
        (strCPF == "22222222222") ||
        (strCPF == "33333333333") ||
        (strCPF == "44444444444") ||
        (strCPF == "55555555555") ||
        (strCPF == "66666666666") ||
        (strCPF == "77777777777") ||
        (strCPF == "88888888888") ||
        (strCPF == "99999999999")) {
        return false;
    }

    let i = 0;
    for (i = 1; i <= 9; i++) Soma = Soma + parseInt(strCPF.substring(i - 1, i)) * (11 - i);
    Resto = (Soma * 10) % 11;

    if ((Resto == 10) || (Resto == 11)) Resto = 0;
    if (Resto != parseInt(strCPF.substring(9, 10))) return false;

    Soma = 0;
    for (i = 1; i <= 10; i++) Soma = Soma + parseInt(strCPF.substring(i - 1, i)) * (12 - i);
    Resto = (Soma * 10) % 11;

    if ((Resto == 10) || (Resto == 11)) Resto = 0;
    if (Resto != parseInt(strCPF.substring(10, 11))) return false;
    return true;
}


// export function CNPJValido(cnpj) {

//     cnpj = cnpj.replace(/[^\d]+/g, '');

//     if (cnpj == '') return false;

//     if (cnpj.length != 14)
//         return false;

//     // Elimina CNPJs invalidos conhecidos
//     if (cnpj == "00000000000000" ||
//         cnpj == "11111111111111" ||
//         cnpj == "22222222222222" ||
//         cnpj == "33333333333333" ||
//         cnpj == "44444444444444" ||
//         cnpj == "55555555555555" ||
//         cnpj == "66666666666666" ||
//         cnpj == "77777777777777" ||
//         cnpj == "88888888888888" ||
//         cnpj == "99999999999999")
//         return false;

//     // Valida DVs
//     let tamanho = cnpj.length - 2
//     let numeros = cnpj.substring(0, tamanho);
//     let digitos = cnpj.substring(tamanho);
//     let soma = 0;
//     let pos = tamanho - 7;
//     let i = 0;
//     for (i = tamanho; i >= 1; i--) {
//         soma += numeros.charAt(tamanho - i) * pos--;
//         if (pos < 2)
//             pos = 9;
//     }
//     let resultado = soma % 11 < 2 ? 0 : 11 - soma % 11;
//     if (resultado != digitos.charAt(0))
//         return false;

//     tamanho = tamanho + 1;
//     numeros = cnpj.substring(0, tamanho);
//     soma = 0;
//     pos = tamanho - 7;
//     for (i = tamanho; i >= 1; i--) {
//         soma += numeros.charAt(tamanho - i) * pos--;
//         if (pos < 2)
//             pos = 9;
//     }
//     resultado = soma % 11 < 2 ? 0 : 11 - soma % 11;
//     if (resultado != digitos.charAt(1))
//         return false;

//     return true;
// }


const limparCNPJ = (value = '') => {
    return String(value || '').replace(/[^0-9a-zA-Z]/g, '').toUpperCase();
}

const valorCaracterCNPJ = (char) => {
    // Novo padrão Receita: valor ASCII do caractere - 48
    return char.charCodeAt(0) - 48;
}

const todosCaracteresIguais = (value) => {
    return /^([A-Z0-9])\1+$/.test(value);
}

export function CNPJValido(cnpj) {
    cnpj = limparCNPJ(cnpj);

    if (!cnpj) return false;
    if (cnpj.length !== 14) return false;

    // 12 primeiras posições podem ser letras/números.
    // 2 últimos dígitos verificadores continuam numéricos.
    if (!/^[A-Z0-9]{12}[0-9]{2}$/.test(cnpj)) return false;

    if (todosCaracteresIguais(cnpj)) return false;

    const pesos1 = [5, 4, 3, 2, 9, 8, 7, 6, 5, 4, 3, 2];
    const pesos2 = [6, 5, 4, 3, 2, 9, 8, 7, 6, 5, 4, 3, 2];

    const calcularDigito = (base, pesos) => {
        const soma = base
            .split('')
            .reduce((total, char, index) => {
                return total + (valorCaracterCNPJ(char) * pesos[index]);
            }, 0);

        const resto = soma % 11;
        return resto < 2 ? 0 : 11 - resto;
    };

    const base12 = cnpj.substring(0, 12);
    const digito1 = calcularDigito(base12, pesos1);

    if (digito1 !== Number(cnpj.charAt(12))) return false;

    const base13 = base12 + digito1;
    const digito2 = calcularDigito(base13, pesos2);

    if (digito2 !== Number(cnpj.charAt(13))) return false;

    return true;
}


export const validateSelect = value => {
    return Boolean(value && value.key);
}

export const checkFormIsValid = (refs) => {
    return Object.keys(refs)
        .map(ref => refs[ref])
        .filter(element => element instanceof InputForm)
        .reduce(((previousValid, input) => {
            return input.isValid() && previousValid;
        }), true)
}



// WEBPACK FOOTER //
// ./src/utils/Validator.js